export default {
  hydrometeorological: 'hydrometeorological',
  groundWater: 'groundWater',
  airQuality: 'airQuality',
  hydrological: 'hydrological'
  }